try {
    require('select2')(); // note you're calling a function here!
} catch (e) {}


$(document).ready(function() {
    $('.js-select2').select2({
        theme: 'bootstrap4',
        placeholder: ''
    });
});
